import FAQs from "components/RevampFeedDetails/JobDetailsPage/components/FAQs";
import { useRouter } from "next/router";
import {
	extractJobType,
	getJobListQNA,
	removeHyphenAndUnderscore,
} from "utils/commonUtils";

const FooterSeoContent = ({ content }) => {
	const router = useRouter();
	if (!content || !content.attributes || !content.attributes.title) return null;

	const { description, title } = content.attributes;
	const displayTitle = removeHyphenAndUnderscore(extractJobType(router.asPath));

	return (
		<div className="bg-[#fff] p-[16px] md:py-[60px]">
			<div className="mx-auto max-w-[1024px]">
				<div className="text-left text-[16px] font-[600] leading-[24px] md:text-[20px] md:font-[700] md:leading-[28px]">
					Know more about {displayTitle}
				</div>
				<div className="mt-[16px] md:mt-[20px] md:rounded-[12px] md:border-[2px] md:border-solid md:border-[#E8E7EA] md:px-[24px]">
					<FAQs faqs={getJobListQNA(description, title)} />
				</div>
			</div>
		</div>
	);
};

export default FooterSeoContent;
